import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxPaginationModule } from 'ngx-pagination';
import { FormsModule, ReactiveFormsModule  } from '@angular/forms';

import { SidebarComponent } from './components/sidebar/sidebar.component';
import { PrintOkComponent } from './components/print-ok/print-ok.component';
import { NoDisponibleComponent } from './components/no-disponible/no-disponible.component';
import { NuevaTransComponent } from './components/nueva-transaccion/nueva-trans.component';
import { TipoTarjetaComponent } from './components/tipo-tarjeta/tipo-tarjeta.component';
import { DatosBancariosComponent } from './components/datos-bancarios/datos-bancarios.component';
import { SeleccionFormaPagoComponent } from './components/seleccion-forma-pago/seleccion-forma-pago.component';
import { ConfirmacionTransaccionComponent } from './components/confirmacion-transaccion/confirmacion-transaccion.component';


// Pipes
import { PesoChilenoPipe } from '../../core/pipes/peso-chileno.pipe';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from './components/header/header.component';


@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    SidebarComponent,
    PrintOkComponent,
    NoDisponibleComponent,
    NuevaTransComponent,
    SeleccionFormaPagoComponent,
    DatosBancariosComponent,
    ConfirmacionTransaccionComponent,
    PesoChilenoPipe,
    TipoTarjetaComponent
  ],
  imports: [
    CommonModule,
    NgxPaginationModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [
    FooterComponent,
    SidebarComponent,
    PrintOkComponent,
    NoDisponibleComponent,
    NgxPaginationModule,
    NuevaTransComponent,
    SeleccionFormaPagoComponent,
    DatosBancariosComponent,
    ConfirmacionTransaccionComponent,
    PesoChilenoPipe,
    HeaderComponent,
    TipoTarjetaComponent
  ]
})
export class SharedModule { }
